import React from 'react';
import '../Estilos/Modal.css';
import '../Estilos/EstiloBotao.css';
export default function ModalView(props) {
  return (
    <div className="modal-background">
      <div className="modal-container">
        {props.children}
      </div>
    </div>
  );
}

function ModalTópico(props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginTop: 37,
        width: '85%',
      }}
    >
      <h5
        style={{
          padding: 0,
          margin: 0,
          fontSize: 24,
          color: '#005288',
          fontFamily: 'montserrat',
          fontWeight: 600,
          textAlign: 'left',
        }}
      >
        {props.titulo}
      </h5>
      <div style={{ height: 3, backgroundColor: '#9ab3d5', width: 94 }}></div>
    </div>
  );
}

function ModalTópicoView(props) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        width: '100%',
      }}
    >
      <h5
        style={{
          padding: 0,
          margin: 0,
          fontSize: 14,
          color: '#E68900',
          fontFamily: 'montserrat',
          fontWeight: 'bold',
          textAlign: 'left',
          marginTop: props.top !== undefined ? props.top : 16,
          marginBottom: props.bottom !== undefined ? props.bottom : 16,
          marginLeft: props.left !== undefined ? props.left : 0,
          marginRight: props.right !== undefined ? props.right : 0,
        }}
      >
        {props.titulo}
      </h5>
    </div>
  );
}

function ModalSubTópico(props) {
  return (
    <h1
      style={{
        width: '90%',
        textAlign: 'left',
        color: '#005288',
        fontFamily: 'montserrat',
        fontSize: '12px',
        fontWeight: 700,
        margin: 0,
        marginTop: props.top !== undefined ? props.top : 16,
      }}
    >
      {props.nome}
    </h1>
  );
}
export { ModalTópico, ModalSubTópico, ModalTópicoView };
